<template>
  <div>

    <HeaderBreadcrumbs
      :items="[{ label: 'Category' }]"
      title="All Category"
    />

    <div class="bg-white w-full rounded-lg my-3 px-0 py-0">
      <div class="flex justify-between py-3 px-4">
        <div class="flex-col relative">
           <svg  class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                            d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                    </svg>
          <input
            type="text"
            class="px-11 py-2.5 border rounded-lg text-sm w-96 h-10"
            v-model="searchInput"
            placeholder="Search Category Name..."
            @input="debounceSearch"
          />
          <button
          v-if="searchInput"
        class="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
        @click="onRefresh"
        title="Clear search"
      >
        ✕
      </button>
        </div>
        <div class="flex justify-end">
          <button class="bg-blue-700 px-3 rounded-lg mr-4 h-10">
            <router-link :to="{ path: '/category/add' }" class="text-white">
              <i class="fa fa-plus"></i> Add New
            </router-link>
          </button>
          <t-dropdown>
            <div
              slot="trigger"
              slot-scope="{ mousedownHandler, focusHandler, blurHandler, keydownHandler }"
              class="flex"
            >
              <button
                class="flex items-center relative justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg"
                @mousedown="mousedownHandler"
                @focus="focusHandler"
                @blur="blurHandler"
                @keydown="keydownHandler"
              >
                <svg
                  class="w-4 h-4 mr-1 text-gray-600 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
                </svg>
                Filter
                <svg
                  class="w-5 h-5 ml-1 text-gray-600 fill-current"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <polygon
                    points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8"
                  />
                </svg>
                 <div v-if="dataBadge"
                  class="rounded-full w-5 h-5 bg-red-600 absolute -top-2 -right-2 text-white text-xs flex justify-center items-center">
                  {{ dataBadge }}
                  </div>
              </button>
            </div>
            <div class="w-custom bg-white absolute -right-2 py-4 border rounded-lg" slot-scope="{ hide, blurHandler }">
               <div class="flex justify-between mb-3 mt-2 px-4">
                  <div>Filter</div>
                  <div @click="hide">
                    <svg class="w-4 h-4 text-gray-800 dark:text-white cursor-pointer" aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>
                  </div>
                </div>
              <div class="block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100" role="menuitem">
                <label class="text-gray-600 font-semibold mb-3">Status</label>
                <StatusFilterComponent
                      v-model="status"
                      :options="statusOptions"
                       :defaultText="`Select Status`"
                    />
                <div class="mt-3">
                  <button class="border bg-blue-700 px-4 py-2 text-white rounded-lg" @click="onStatusChange" @blur="blurHandler">
                    Filter
                  </button>
                  <button class="border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2" @click="onReset()" @blur="blurHandler">Reset</button>
                </div>
              </div>
            </div>
          </t-dropdown>
        </div>
      </div>
      <div class="bg-white w-full mt-0 mb-3 rounded-lg pt-0 pb-2 shadow-none overflow-hidden">
        <div ref="scrollContainer" class="relative">
           <Table
    :headers="headers"
      :data="this.items"
      :row-key="['name', 'slug', 'category_bisac', 'category_ax', 'is_active', 'created','modified']"
      :current-page="currentPage"
      :isLoading="isLoading"
      :per-page="perPage">
        
       <template #header-created-date="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
         <template #header-modified-date="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
         <template #created="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
         <template #category_bisac="{ row }">
          <span>{{ row.category_bisac?.name ?? '-' }}</span>
        </template>
          <template #category_ax="{ row }">
          <span>{{ row.category_ax?.ax.code ?? '-' }}</span>
        </template>
         <template #modified="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
         <template #is_active={value}>
         <div style="" class="text-center py-1 px-1.5 rounded-lg w-auto" :class="{ 'bg-green-100': value === true, 'bg-gray-100': value === false }">
            <span v-if="value">
              Active
            </span>
            <span v-else>
              Inactive
            </span>
          </div>

        </template>
         <template #actions="{ row }">
          <router-link :to="{ path: '/category/edit/' + row.id }"
            class="link text-gray-600 align-middle items-center flex justify-center">
            <svg class="w-6 h-6 text-gray-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                clip-rule="evenodd" />
              <path fill-rule="evenodd"
                d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                clip-rule="evenodd" />
            </svg>
          </router-link>
          </template>
  </Table>
        </div>
        <div v-if="!isLoading && this.items.length" class="flex bg-white justify-between px-4 pl-0 pr-3 pt-4 mb-0 border-t border-gray-100 mt-1">
          <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
          </div>
          <div class="mb-2">
            <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
              @change="onClickPage" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters, mapActions } from 'vuex';
import StatusFilterComponent from '../../components/form/StatusFilterComponent.vue';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import Table from '@/components/form/table.vue';
export default {
  name: 'category',
  components: {
    StatusFilterComponent,
    HeaderBreadcrumbs,
    Table
  },
  data() {
    return {
      currentPage: 1,
      perPage: 15,
      filter: {},
      searchInput:"",
      dataBadge:null,
      sorts:[],
      sort_field: "",
      sortOrder: '',
      isLoadingSearch: false,
      items_search: [],
        headers: [
        { label: 'No', key: 'no' },
        { label: 'category name', key: '' },
        { label: 'slug', key: '' },
        { label: 'category bisac', key: '' },
        { label: 'category AX', key: ''},
        { label: 'Status', key: '' },
        { label: 'Created Date', key: 'created',sortable: true, slotHeader: 'header-created-date' },
        { label: 'Last Modified', key: 'modified',sortable: true, slotHeader: 'header-modified-date' },
       
      ],
      message: null,
      status: null,
      isSticky: false,
      statusOptions: [
        { value: null, text: 'All Status' },
        { value: 1, text: 'Active' },
        { value: 2, text: 'Inactive' },
      ],
    };
  },
  computed: {
    ...mapGetters('category', { items: 'category' }),
    ...mapState({
      isLoading: (state) => state.category.isLoading,
      isError: (state) => state.category.isError,
      totalRows: (state) => state.category.totalRows,
    }),
  },
  mounted() {
    this.actionGetCategory();
  },
  watch: {
    currentPage: function () {
      this.actionGetCategory();
    },
    totalRows(updateValue) {
        if (updateValue < 100) {
            this.currentPage = 1;
        }
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Category | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  methods: {
    ...mapActions('category', ['fetchAll', 'search', 'editStatus']),
    actionGetCategory() {
      let payload = {
        page: this.currentPage,
        limit: this.perPage,
        is_active: this.status,
      };
      this.fetchAll(payload);
    },
    onRefresh() {
      this.actionGetCategory()
      this.searchInput = ""
      this.message = null
    },
    debounceSearch(event) {
      this.message = null;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.typing = null;
        this.message = event.target.value;

        this.fetchAll({
          name: event.target.value,
          page: 1,
          limit: this.perPage,
          is_active: this.status,
          ...(this.sort_field && { sort_field: this.sort_field }),
          ...(this.sortOrder && { sort: this.sortOrder }),
        });
      }, 600);
    },
    formatPriceBasic(value) {
      let val = (value / 1).toFixed(0).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatDate(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss'),
      };
    },
    onStatusChange() {
      let payload = {
        is_active: this.status,
        page: this.totalRows < 100 ? 1 : this.currentPage,
        limit: this.perPage,
        ...(this.sort_field && { sort_field: this.sort_field }),
        ...(this.sortOrder && { sort: this.sortOrder }),

      };

      if (this.message) payload.name = this.message;
      this.fetchAll(payload);
      this.filterBadge()
    },
     sortBy(column) {
      let existingIndex = this.sorts.findIndex(s => s.column === column);

      if (existingIndex >= 0) {
        this.sorts[existingIndex].order =
        this.sorts[existingIndex].order === "asc" ? "desc" : "asc";

        const [item] = this.sorts.splice(existingIndex, 1);
        this.sorts.unshift(item);
      } else {
        this.sorts.unshift({ column, order: "asc" });
      }

      let sortString = this.sorts
        .map(s => `${s.column}_${s.order}`)
        .join(',');

      let payload = {
        is_active: this.status,
        page:  this.currentPage,
        limit: this.perPage,
        sort_field:this.sort_field,
        sort:sortString
      };

      if (this.message) payload.name = this.message;
      this.fetchAll(payload);
    },

     filterBadge() {
      let badgeCount = 0;
      badgeCount += [this.status].filter(status => status != null).length;

      this.dataBadge = badgeCount > 0 ? badgeCount : null;
    },
    onReset() {
      let payload = {
        is_active:  this.status = null,
        page: this.currentPage,
        limit: this.perPage,
        sort_field:"",
        sort:""
      };
      if (this.message) payload.name = this.message;
      this.fetchAll(payload);
      this.dataBadge = null
    },
    onClickPage(page) {
      this.currentPage = page;
    },
  },
};
</script>

<style scoped>
@import '../../assets/css/table.css';
.sticky-header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
  transition: all 0.3s;
}
.w-custom {
  width: 540px;
}
</style>
